import React, { useState } from 'react';

interface TruncatedTextProps {
    text: string;
    limit?: number;
    className?: string;
}

export function TruncatedText({
    text,
    limit = 20,
    className,
}: TruncatedTextProps) {
    const [isExpanded, setIsExpanded] = useState(false);

    if (!text) return null;

    const isTruncated = text.length > limit;

    const displayText =
        isExpanded || !isTruncated
            ? text
            : text.slice(0, limit);

    return (
        <span className={className}>
            {displayText}
            {!isExpanded && isTruncated && '... '}
            {!isExpanded && isTruncated && (
                <span

                    onClick={() => setIsExpanded(true)}
                    className=" ml-1 cursor-pointer text-muted-foreground whitespace-nowrap text-primary"
                >
                    read more
                </span>
            )}
        </span>
    );
}
